import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { accessPermission } from '@m/user/permissions'
// import { IS_CLIENT } from '@m/user/accessTokens'

const PROFILE_PREFIX = 'cabinet:staff'
const p = (name: string) => PROFILE_PREFIX + ':' + name

export const CREATE_STAFF_VIEW_NAME = p('create-view')
export const STAFF_CATALOG_VIEW_NAME = p('catalog-view')
export const STAFF_DETAILS_VIEW_NAME = p('details-view')

const CreateStaffView = () => import('./views/CreateStaff.vue')
const StaffCatalogView = () => import('./views/StaffCatalog.vue')
const StaffDetailsView = () => import('./views/StaffDetails.vue')

const BASE_MODEL_NAME = 'staff/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  // console.log('createRoutes в cabinet/modules/Staff.router.ts')

  return [
    route(
      'create/',
      CreateStaffView,
      CREATE_STAFF_VIEW_NAME, //cabinet/staff/create-view
      {
        meta: {
          title: () => $t('Створити співробітника'),
        },
    }),
    route(
      'catalog/',
      StaffCatalogView,
      STAFF_CATALOG_VIEW_NAME, //cabinet/staff/catalog
      {
        meta: {
          title: () => $t('Усі співробітники'),
        },
    }),
    route(
      'details/:id/',
      StaffDetailsView,
      STAFF_DETAILS_VIEW_NAME, //cabinet/staff/details/{id}/
      {
        meta: {
          title: () => $t('Усі співробітники'),
          fallbackRouteName: STAFF_CATALOG_VIEW_NAME,
        },
    }),
  ]
}

export { BASE_MODEL_NAME }